var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.primeiraVez)?_c('div',{staticClass:"tela"},[_c('div',{staticClass:"conteudo"},[_vm._v(" Carregando ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }